import { OnlineSales } from 'gw-edge-client';
import { selector } from 'recoil';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import type { DogClubDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/pet';

export const getDogClubOptionsSelector = selector<DogClubDTO[]>({
    key: 'getDogClubOptionsSelector',
    get: async ({ get }) => {
        const { jobNumber, sessionId } = get(jobInfoAtom);

        return await OnlineSales.getDogClubOptions(jobNumber, sessionId);
    }
});
